import { useEffect, useRef } from 'react';

export const useFirstRender = () => {
  const isMounted = useRef(true);
  useEffect(() => {
    isMounted.current = false;
  }, []);
  return isMounted.current;
};
